module.exports = __webpack_public_path__ + "img/Profile_avatar_placeholder_large.f8abc5f.png";